/** Pure BOQ-paste parser for the qty-override grid (spec §5.3 bulk override). */
export interface BomParseResult {
    overrides: { taskKey: string; qty: number }[];
    errors: string[];
}

export function parseBomPaste(text: string, knownKeys: Set<string>): BomParseResult {
    const overrides: { taskKey: string; qty: number }[] = [];
    const errors: string[] = [];
    const lines = text
        .split(/\r?\n/)
        .map((l) => l.trim())
        .filter(Boolean);
    lines.forEach((line, idx) => {
        const parts = line.split(/[\t ,]+/).filter(Boolean);
        if (parts.length < 2) {
            errors.push(`Line ${idx + 1}: expected "taskKey  qty"`);
            return;
        }
        const taskKey = parts[0] as string;
        const qty = Number(parts[1]);
        if (!knownKeys.has(taskKey)) {
            errors.push(`Line ${idx + 1}: unknown task '${taskKey}'`);
            return;
        }
        if (!Number.isFinite(qty) || qty <= 0) {
            errors.push(`Line ${idx + 1}: qty must be a positive number`);
            return;
        }
        overrides.push({ taskKey, qty });
    });
    return { overrides, errors };
}
